import { Toast } from '@curology/ui-components-web/react/Toast';
import { useAtom } from 'jotai';
import React from 'react';

import { FlashMessagesState } from '@/atoms/flashMessages/flashMessagesState';

const FlashMessages: React.FC = () => {
  const [flashMessages] = useAtom(FlashMessagesState.flashMessagesAtom);

  return (
    <>
      {flashMessages.map((flashMessage, index) => (
        <Toast key={index} {...flashMessage}>
          {flashMessage.children}
        </Toast>
      ))}
    </>
  );
};

export default FlashMessages;
